'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _strategies = require('./strategies');

var _strategies2 = _interopRequireDefault(_strategies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var matches = function matches() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var value = _ref.value;
  var query = _ref.query;
  var _ref$strategy = _ref.strategy;
  var strategy = _ref$strategy === undefined ? _strategies2.default.infix : _ref$strategy;
  var _ref$transform = _ref.transform;
  var transform = _ref$transform === undefined ? function (v) {
    return v.toLowerCase();
  } : _ref$transform;

  if (!query) {
    return {};
  }

  var val = value && value.toString ? value.toString() : '';

  return strategy(transform(query)).matches(transform(val));
};

exports.default = matches;


//////////////////
// WEBPACK FOOTER
// ./~/reactabular-search/dist/matches.js
// module id = 1400
// module chunks = 0